import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Link, Tooltip, Typography } from "@mui/material";
import React, { Suspense, useState } from "react";
import useDetail from "../../../../hooks/useDetail.ts";
import { isEvyveska } from "../../../../utills/iframeVariants.ts";

interface TextWithLinksProps {
	text: string;
}

const TextWithLinks: React.FC<TextWithLinksProps> = ({ text }) => {

  if(isEvyveska()) {
    return text;
  }

  // Regular expression to match URLs
	const urlPattern = /https?:\/\/\S+/g;

	// Split the text into segments: part of the text that are URLs and other text
	const segments = text.split(urlPattern);

	// Find the URLs in the text
	const urls = text.match(urlPattern) || [];

	// Create a new array where URLs are replaced by <Link> components
	const content = segments.map((segment, index) => {
		if (index < urls.length) {
			// Add the URL wrapped in a MUI <Link> component
			return (
				<React.Fragment key={segment}>
					{segment}
					<Link href={urls[index]} target="_blank" rel="noopener noreferrer">
						{urls[index]}
					</Link>
				</React.Fragment>
			);
		}
		return <span key={segment}>{segment}</span>;
	});

	return <Typography sx={{ whiteSpace: "pre-wrap" }}>{content}</Typography>;
};

const AdditionalInfo: React.FC<{ id: number }> = ({ id }) => {
	const [expandedAdditionalInfo, setExpandedAdditionalInfo] = useState<boolean>(true);
	const detail = useDetail(id);

	const dalsiInformace = detail.data.attributes.dalsiInformace;

	if (!dalsiInformace) {
		return null;
	}

	return (
		<Accordion expanded={expandedAdditionalInfo}>
			<Tooltip
				followCursor={true}
				placement="right"
				title={expandedAdditionalInfo ? "Skrýt další informace" : "Zobrazit další informace"}
			>
				<AccordionSummary
					onClick={() => setExpandedAdditionalInfo(!expandedAdditionalInfo)}
					sx={{ backgroundColor: "grey.200" }}
					expandIcon={<ExpandMore fontSize="medium" color="secondary" />}
				>
					<Typography fontWeight="bolder" sx={{ color: "info.main" }} variant="subtitle1" component="div">
						Další informace
					</Typography>
				</AccordionSummary>
			</Tooltip>
			<AccordionDetails sx={{
        paddingTop: 3,
        paddingBottom: 3,
        paddingLeft: 4,
        paddingRight: 4,
      }}>
				<TextWithLinks text={dalsiInformace} />
			</AccordionDetails>
		</Accordion>
	);
};

const AdAdditionalInfo: React.FC<{ id: number }> = ({ id }) => {
	return (
		<Suspense>
			<AdditionalInfo id={id} />
		</Suspense>
	);
};

export default AdAdditionalInfo;
